import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/entity/:appId',
      name: 'Entity',
      meta: {
        title: '实体模板'
      },
      component: resolve => require(['../pages/Entity.vue'], resolve)
    },
    {
      path: '/entity',
      name: 'Entity',
      meta: {
        title: '实体模板'
      },
      component: resolve => require(['../pages/oldEntity.vue'], resolve)
    },
    {
      path: '/huangye/:appId',
      name: 'Huangye',
      meta: {
        title: '黄页模板'
      },
      component: resolve => require(['../pages/Huangye.vue'], resolve)
    },
    {
      path: '/huangye',
      name: 'Huangye',
      meta: {
        title: '黄页模板'
      },
      component: resolve => require(['../pages/oldHuangye.vue'], resolve)
    },
    {
      path: '/album/:appId',
      name: 'Album',
      meta: {
        title: '相册模板'
      },
      component: resolve => require(['../pages/Album.vue'], resolve)
    },
    {
      path: '/album',
      name: 'Album',
      meta: {
        title: '相册模板'
      },
      component: resolve => require(['../pages/oldAlbum.vue'], resolve)
    },
    {
      path: '/model/:appId',
      name: 'Model',
      meta: {
        title: '三维模型模板'
      },
      component: resolve => require(['../pages/Model.vue'], resolve)
    },
    {
      path: '/albumpc/:appId',
      name: 'albumpc',
      meta: {
        title: '相册pc端模板'
      },
      component: resolve => require(['../pages/AlbumPc.vue'], resolve)
    },
    {
      path: '/expo/:appId',
      name: 'Expo',
      meta: {
        title: '展会模板'
      },
      component: resolve => require(['../pages/ExpoPc.vue'], resolve)
    },
    {
      path: '/expopc/:appId',
      name: 'expopc',
      meta: {
        title: '展会PC端模板'
      },
      component: resolve => require(['../pages/ExpoPc.vue'], resolve)
    },
    {
      path: '/expo/:appId',
      name: 'expo',
      meta: {
        title: '展会移动端模板'
      },
      component: resolve => require(['../pages/ExpoPc.vue'], resolve)
    },
    {
      path: '/model',
      name: 'Model',
      meta: {
        title: '三维模型模板'
      },
      component: resolve => require(['../pages/oldModel.vue'], resolve)
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        title: '测试iframe'
      },
      component: resolve => require(['../pages/Test.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js